export default __webpack_public_path__ + "static/triangle-right1-699c5f65bb8fb342ecaac7047eed114d.png";